import React from 'react';

import ContactForm from '../ContactFrom';
import './style.css';

const Contactpage = () => {
  return (
    <section className="wpo-contact-form-map section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="contact-form">
                  <h2>Get In Touch</h2>
                  <ContactForm />
                </div>
              </div>
              <div className="col col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="contact-map">
                  <iframe
                    width="600"
                    height="500"
                    id="gmap_canvas"
                    src="https://maps.google.com/maps?q=vancouver,%20canada&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    title="location"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="wpo-contact-info">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="info-item">
                    <h2>HEAD OFFICE: Vancouver, Canada</h2>
                    <h2>
                      LHCF Office/Centre in Rwanda: KG 436 Kagugu, Kigali, Rwanda
                    </h2>
                    <div className="info-wrap">
                      <div className="info-icon">
                        <i className="ti-world"></i>
                      </div>
                      <div className="info-text">
                        <span>Office Address</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="info-item">
                    <h2>info@lovehopeandcarefoundation.org</h2>
                    <div className="info-wrap">
                      <div className="info-icon-2">
                        <i className="fi flaticon-envelope"></i>
                      </div>
                      <div className="info-text">
                        <span>Official Mail</span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="info-item">
                    <h2>+1 (604) 445-9066, +250 784 089 536</h2>
                    <div className="info-wrap">
                      <div className="info-icon-3">
                        <i className="ti-headphone-alt"></i>
                      </div>
                      <div className="info-text">
                        <span>Official Phone</span>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactpage;
